export default __webpack_public_path__ + "static/media/for-players-direct.d6d8c6f7.svg";